"use client";
import { cn as e } from "../../../utils/utils.mjs";
import { Skeleton as t } from "../../atoms/Skeleton/Skeleton.mjs";
import { JUSTIFIED_GALLERY_DEFAULT_HEIGHTS as n } from "./constants.mjs";
import { getGapStyle as r, getItemRenderData as i, getItemStyleProps as a } from "./utils.mjs";
import { jsx as o, jsxs as s } from "react/jsx-runtime";
//#region src/components/layouts/JustifiedGallery/JustifiedGallery.tsx
var c = "h-(--h-sm) @min-[768px]/gallery:h-(--h-md) @min-[1024px]/gallery:h-(--h-lg) @min-[1800px]/gallery:h-(--h-xl)", l = ({ items: l, responsiveHeights: u = n, rowGapPx: d = 8, columnGapPx: f = 8, className: p, children: m, stretchLastRow: h = !1, isLoading: g = !1, skeletonProps: _, ...v }) => /* @__PURE__ */ s("div", {
	"data-testid": "justified-gallery",
	className: e("flex flex-wrap @container/gallery", p),
	style: {
		gap: r(d, f),
		"--h-sm": `${u?.sm}px`,
		"--h-md": `${u?.md}px`,
		"--h-lg": `${u?.lg}px`,
		"--h-xl": `${u?.xl}px`
	},
	...v,
	children: [l.map((n, r) => {
		let s = i(n, r), l = a(s.aspectRatio);
		return g ? /* @__PURE__ */ o(t, {
			"data-testid": `skeleton-loader-${n.id}`,
			animation: "shimmer",
			..._,
			className: e(c, _?.className),
			style: {
				..._?.style,
				...l
			}
		}, n.id) : /* @__PURE__ */ o("div", {
			"data-testid": `justified-gallery-item-${n.id}`,
			className: c,
			style: l,
			children: m(s)
		}, n.id);
	}), !h && l.length > 0 && /* @__PURE__ */ o("div", {
		"aria-hidden": !0,
		"data-testid": "justified-gallery-row-filler",
		style: {
			flexGrow: 1e6,
			flexBasis: 0
		}
	})]
});
//#endregion
export { l as JustifiedGallery };
